import React from "react";
import "./Footer.css";

import {
  FaFacebookF,
  FaInstagram,
  FaXTwitter,
} from "react-icons/fa6";


const Footer = () => {

  return (
    <footer className="main-backdiv">
      <div className="footer-div">
        <div>
          <div className="footer-img">
            <img
              src="/kaveri-logo.webp"
              alt="Kaveri Logo"
              className="cover-img"
              loading="lazy"
              width={200}
              height={100}
            />
          </div>
          <p className="card-text">
            Kaveri Group is a real estate development group with commercial and mixed-use developments in Greater Noida. Its portfolio includes Kaveri City Centre 1 and Kaveri City Centre 2 at Delta-1, with offerings including retail shops, commercial spaces and studio apartments. With a focus on strategic locations, contemporary planning and urban connectivity, Kaveri Group aims to create relevant destinations for businesses, investors and modern city users.
          </p>
          <div className="social-links">
            <a
              href="https://www.facebook.com/KAVERIGROUPCITYCENTRE"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/kavericitycentre_official/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaInstagram />
            </a>
            <a
              href="https://x.com/KaveriCity"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaXTwitter />
            </a>
          </div>
        </div>
        <div className="foot-sectiondiv">
          <div>
            <h6>
              Explore
            </h6>
            <ul>
              <li>
                <a href="/project">
                  Projects
                </a>
              </li>

              <li>
                <a href="/about-us">
                  About Us
                </a>
              </li>

              <li>
                <a href="/career">
                  Career
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h6>
              Company
            </h6>
            <ul>
              <li>
                <a href="/blog">
                  Blogs
                </a>
              </li>
              <li>
                <a href="/contact-us">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h6>
              Contact
            </h6>
            <ul>
              <li>
                <a href="mailto:info@kaverigroups.org">
                  info@kaverigroups.org
                </a>
              </li>
              <li>
                <a href="tel:80-1052-1052">
                  80-1052-1052
                </a>
              </li>
              <li className="foot-address">Plot No.- C6, 3rd Floor, Kaveri City Centre, Delta-1,
                  Greater Noida, Uttar Pradesh - 201308</li>
            </ul>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        <p className="card-text text-center">
          © {new Date().getFullYear()} Kaveri Group.
          All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};


export default Footer;